export default "__VITE_ASSET__wd3kEGOs__"